<template>
  <div class="chart-board" :style="chartBoardStyle">
    <div class="chart-board-card" v-if="!showPlacehold">
      <div class="chart-board-title" v-if="chartTitleVisible">{{chartTitle}}</div>
      <div class="chart-board-data">{{boardData.value | numFormat}}</div>
      <div class="chart-board-ratio" v-if="linkRelativeRatio">
        <span>{{linkRelativeRatioType | ratioTypeFilter}}</span>
        <span
          class="chart-board-num"
          :class="boardData.linkRelativeRatioValue < 0 ? 'ratio-red':'ratio-green'">
          {{boardData.linkRelativeRatioValue | ratioFilter}}
        </span>
        <span
          v-if="boardData.linkRelativeRatioValue"
          :class="boardData.linkRelativeRatioValue < 0 ? 'el-icon-bottom':'el-icon-top'">
        </span>
      </div>
    </div>
    <img
      src="http://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/01/1642400391459.png" alt=""
      class="placehold-img"
      v-if="showPlacehold"
    >
  </div>
</template>

<script>
var self;
export default {
  name: "chartBoard",
  props: {
    receiveProps:{
      type: [Object, Array],
      default: ()=>{}
    }
  },
  filters: {
    ratioFilter(val) {
       if (!val && val !==0) {
        return '--'
      } else {
        return (
          Math.abs(val) + '%'
        )
      }
    },
    numFormat(num) {
      if (!num && num !==0) return
      let {dataContent} = self.receiveProps.tempData.boardData;
      let unitOfQuantity = dataContent.unitOfQuantity ? dataContent.unitOfQuantity : 1 // 数量单位
      let value = num / unitOfQuantity; // 当前数值/数量单位
      let decimalDigits = dataContent.decimalDigits ? dataContent.decimalDigits : 0; // 小数点位数
      let unitSuffixes = dataContent.unitSuffixes ? dataContent.unitSuffixes : ''; // 后缀
      let result = value.toFixed(decimalDigits) // 截取小数点
       return result == 0 ? 0 + unitSuffixes : String(result).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g,'$1,') + unitSuffixes
    },
    ratioTypeFilter(val) {
      let text = '环比：'
      switch(val) {
        case 0:
          text = '日环比：'
          break;
        case 2: 
          text = '月环比：'
          break;
        case 3: 
          text = '年环比：'
          break;
        default: 
          return '环比：'
      }
      return text
    }
  },
  computed: {
    chartBoardStyle() {
      if (!this.receiveProps.tempData.boardData) return
      let {
       dataSettings
      } = this.receiveProps.tempData.boardData;
      return {
        // 左右间距
        "--padding-right": `${dataSettings.blockpadRight}px`,
        "--padding-left": `${dataSettings.blockpadLeft}px`,
      };
    },
  },
  beforeCreate: function () {
    self = this;
  },
  data() {
    return {
      chartTitle: '', // 标题
      chartTitleVisible: false, // 标题显隐
      showPlacehold: false, //是否显示占位
      linkRelativeRatio: false, // 是否环比,
      linkRelativeRatioType: '', // 环比类型
      boardData: {
        linkRelativeRatioValue: null,//环比值
        value: null, //指标版数据
      }
    }
  },
  mounted() {
    console.log(this.receiveProps,'chart-board')
    this.getChartBoard()
  },
  methods: {
    async getChartBoard() {
      let boardData = this.receiveProps.tempData.boardData;
      if (!boardData) { //占位图显隐
        this.showPlacehold = true;
        return;
      }
      let {dataContent, dataSet, dataSettings} = boardData;
      this.chartTitle = dataSettings.chartTitle;
      this.chartTitleVisible = dataSettings.chartTitleVisible;
      this.linkRelativeRatio = dataContent.linkRelativeRatio;
      this.linkRelativeRatioType = dataContent.linkRelativeRatioType;
      let param = {
        column: dataContent.measurement.tableColumnName,
        dashBoardFilter: {
          enumId: dataContent.dateFilter,
          tableColumnName: "dim_date_type",
        },
        dataSetId: dataSet.id,
        linkRelativeRatio: dataContent.linkRelativeRatio,
        linkRelativeRatioCode: dataContent.linkRelativeRatioType
      }
      try {
        let res = await this.$apipcs.chart.getChartBoard(param);
        if (res.success) {
          this.boardData = Object.assign(this.boardData,res.data);
        }
      } catch(err) {
        console.log(err);
      }
    }
  }
};
</script>

<style lang="less" scoped>
  .chart-board {
    max-width: 1200px;
    margin: 0 auto;
    margin-bottom: 16px;
    padding-right: var(--padding-right);
    padding-left: var(--padding-left);
    box-sizing: border-box;
  }
  .chart-board-card {
    width: 100%;
    text-align: left;
    height: 134px;
    padding: 16px;
    box-sizing: border-box;
    background: #FFF;
    .chart-board-title {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      margin-bottom: 8px;
    }
    .chart-board-data {
      font-size: 32px;
      font-family: Arial-BoldMT, Arial;
      font-weight: bold;
      color: #333333;
      margin-bottom: 16px;
    }
    .chart-board-ratio {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .chart-board-num {
      margin-right: 4px;
    }
    .el-icon-top {
      font-weight: bold;
      font-size: 16px;
      color: #00C184;
    }
    .el-icon-bottom {
      color: #FF5454;
      font-weight: bold;
      font-size: 16px;
    }
    .ratio-red {
      color: #FF5454;
    }
    .ratio-green {
      color: #00C184;
    }
  }

</style>